"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var helios_forms_1 = require("@carvana/helios-forms");
var helios_layout_1 = require("@carvana/helios-layout");
var helios_styles_1 = require("@carvana/helios-styles");
var test_attributes_1 = require("@carvana/test-attributes");
var styled_components_1 = __importDefault(require("styled-components"));
var VinInfoModal_1 = __importDefault(require("../VinInfoModal"));
var VinForm = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  box-sizing: border-box;\n  width: 100%;\n  text-align: left;\n  ", ";\n"], ["\n  box-sizing: border-box;\n  width: 100%;\n  text-align: left;\n  ", ";\n"])), helios_layout_1.breakpoint.md(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n  "], ["\n    display: flex;\n  "]))));
var VinEntry = function (_a) {
    var _b = _a.hasError, hasError = _b === void 0 ? false : _b, _c = _a.error, error = _c === void 0 ? undefined : _c, getTestAttributes = _a.getTestAttributes, updateVin = _a.updateVin, vin = _a.vin, props = __rest(_a, ["hasError", "error", "getTestAttributes", "updateVin", "vin"]);
    var isMobile = (0, helios_layout_1.useMediaQuery)("(max-width: ".concat(helios_styles_1.breakpoint.md, ")"));
    return ((0, jsx_runtime_1.jsxs)(VinForm, { children: [(0, jsx_runtime_1.jsx)(helios_forms_1.TextInput, __assign({}, getTestAttributes('Input'), { error: error, hasError: hasError, id: "VIN", value: vin, label: "VIN", maxLength: 17, minLength: 17, onChange: updateVin, touched: hasError || (vin === null || vin === void 0 ? void 0 : vin.length) === 17, width: isMobile ? '100%' : '284px', style: { width: isMobile ? '100%' : '284px' } }, props)), (0, jsx_runtime_1.jsx)(VinInfoModal_1.default, {})] }));
};
exports.default = (0, test_attributes_1.appendTestContext)('VinEntry')((0, test_attributes_1.withTestFunc)(VinEntry));
var templateObject_1, templateObject_2;
